import { QqActionData, QqActionType, RESET_ACTION } from "../qq-action.type";

export const resetAction: () => QqActionType = () => {
  return {
    type: RESET_ACTION,
    data: {} as QqActionData,
  };
};
